import { Select, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCurrentStudyYear, useStudyYears } from '../hooks/useStudyYear';

interface StudyYearDropdownProps {
  // input: id of the selected study year, the current one is shown until another is chosen
  value?: number;
  // output: called with the id of the study year the user selected
  onChange: (studyYearId: number) => void;
}

export const StudyYearDropdown = ({
  value,
  onChange,
}: StudyYearDropdownProps): React.ReactElement => {
  const { t } = useTranslation();
  const { data: studyYears = [], isLoading } = useStudyYears();
  const { data: currentStudyYear } = useCurrentStudyYear();

  // the newest study year first
  const options = [...studyYears]
    .sort((a, b) => b.id - a.id)
    .map((studyYear) => ({
      value: studyYear.id,
      label: (
        <>
          {studyYear.name}{' '}
          {studyYear.id === currentStudyYear?.id && (
            <Tag color="blue">{t('studyYear.current')}</Tag>
          )}
        </>
      ),
    }));

  return (
    <Select
      style={{ minWidth: 220 }}
      loading={isLoading}
      value={value ?? currentStudyYear?.id}
      options={options}
      onChange={onChange}
    />
  );
};
